import { Alert, Box, Button, Collapse, Container, Link, TextField, Typography } from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { UserContext } from "../theme/userContext";
import { Stack } from "@mui/system";

export default function Login() {

  const navigate = useNavigate();

  const { user, error: contextError, setError: setContextError, onLogin } = useContext(UserContext);
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [info, setInfo] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();

    // validate the inputs
    if (!email || !password) {
      setError("Please enter your email and password.");
      return;
    }

    // clear the errors
    setError("");
    setInfo("");
    setContextError("");

    try {
      await onLogin(email, password);
      navigate("/feed", { replace: true });
    } catch (error) {
      console.error(error.message);
      if ((error.message || "").includes("Passwort-Reset erforderlich")) {
        setInfo(error.message);
      } else {
        setError(error.message);
      }
    }
  }

  const onPasswordReset = async () => {

    // validate the inputs
    if (!email) {
      setError("Please enter your email.");
      return;
    }

    // clear the errors
    setError("");
    setInfo("");
    setContextError("");

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URI}/api/auth/password/forgot`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email.toLowerCase() }),
      });
      if (!response.ok) {
        throw new Error("Passwort-Reset konnte nicht ausgelöst werden.");
      }
      setInfo("Es wurde eine Mail zum Passwort Reset versendet!");
    } catch (error) {
      console.error(error.message);
      setError(error.message);
    }

  }


  return (
    <Box
      component="main"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexGrow: 1,
        minHeight: '100%'
      }}
    >
      <Container maxWidth="xs" sx={{ mt: 12 }}>
        <Typography variant="h5" component="h1" gutterBottom textAlign="center">
          Finalyser Login
        </Typography>
        {contextError && <Alert severity="error" sx={{ my: 2 }}>{contextError}</Alert>}
        {error && <Alert severity="error" sx={{ my: 2 }}>{error}</Alert>}
        <Box component="form" onSubmit={onSubmit}>
          <TextField
            label="Email"
            variant="outlined"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value.toLowerCase())}
            sx={{ mt: 1 }}
            fullWidth
          />
          <TextField
            label="Password"
            variant="outlined"
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ mt: 3 }}
            fullWidth
          />
          <Button variant="contained" type="submit" sx={{ mt: 3 }} fullWidth>Login</Button>
          <Stack direction="row" sx={{ mt: 4 }} alignItems="center" justifyContent="center">
            <Typography variant="body2">Ich habe noch kein Profil.</Typography>
            <Link ml={1} variant="body2" href="/register">Jetzt registrieren!</Link>
          </Stack>
          <Stack direction="row" sx={{ mt: 1 }} alignItems="center" justifyContent="center">
            <Typography mr={1} variant="body2">Passwort vergessen?</Typography>
            <Link component="button" variant="body2" onClick={onPasswordReset} >Neues Passwort per Mail anfordern</Link>
          </Stack>
        </Box>
        <Collapse in={Boolean(info)}>
          <Alert mt={2} severity="success">{info}</Alert>
        </Collapse>
        {(user && user.hasOwnProperty('p_user')) && <Navigate to="/feed" state={user} replace={true} />}
      </Container>
    </Box>
  )
}
